import React from "react";
import { Modal, Row, Form, Icon, message, Popconfirm, Spin } from "antd";
import Slider from "react-slick";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { withFirebase } from "../../firebase";
import {
  LinkText,
  H4,
  CustomDragger,
  ModalCustom,
  ContainerImg,
} from "./style";

const urlEndPoint = process.env.REACT_APP_API_ENDPOINT;
const functionUpload = process.env.REACT_APP_NAME_UPLOAD_ALL;

class ModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validFormats: null,
      loadingSpin: false,
    };
  }

  componentDidMount = () => {
    this.props.validFormats
      ? this.setState({
          validFormats: this.props.validFormats,
        })
      : this.setState({
          validFormats: ["", "image/png", "image/jpeg", "image/jpg"],
        });
  };

  beforeUpload = file => {
    if (this.state.validFormats) {
      if (this.state.validFormats.indexOf(file.type) >= 0) {
        return true;
      }
      message.error(`Suba archivos válidos ${this.state.validFormats}`);
      return false;
    }
    return true;
  };

  fileNameStamp = name => {
    const getDate = new Date();
    getDate.setHours(getDate.getHours() - 5);
    let timestamp = getDate.toISOString();
    timestamp = timestamp.replace(/:/g, "-");
    timestamp = timestamp.replace(/\./g, "-");
    return timestamp + name.replace(/ /g, "_");
  };

  customPost = ({ file, onError, onProgress, onSuccess }) => {
    const { firebase, folderName, target } = this.props;

    const fileStamp = this.fileNameStamp(file.name);
    const key = `${folderName}/${target}/${fileStamp}`;

    const task = firebase.refStorage.child(key).put(file);
    this.setState({ loadingSpin: true });
    task.on(
      "state_changed",
      function progress(snapshot) {
        const percentage =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        onProgress({ percent: percentage });
      },
      err => {
        message.error("Error al subir archivo");
        this.setState({ loadingSpin: false });
        return onError(err);
      },
      () => {
        task.snapshot.ref.getDownloadURL().then(downloadURL => {
          const { name, uid, url = downloadURL, status = "done" } = file;
          onSuccess({ name, uid, url, status, file: downloadURL });
          this.props.updateFieldURL(url);
          this.setState({ loadingSpin: false });
        });
      }
    );
  };

  render = () => {
    const { visible, onHandleCancelModal, srcFile } = this.props;

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    const renderImgs = (
      <ContainerImg key="1">
        <div>
          <img alt="img" src={srcFile} />
        </div>

        <div className="btn-delete">
          <Popconfirm
            placement="top"
            title="Esta seguro de eliminar la foto."
            onConfirm={() => this.props.updateFieldURL(null)}
            okText="Si"
            cancelText="No"
          >
            Eliminar Image <Icon type="delete" />
          </Popconfirm>
        </div>
      </ContainerImg>
    );

    return srcFile ? (
      <ModalCustom
        title={null}
        footer={null}
        visible={visible}
        onCancel={onHandleCancelModal}
        closable={false}
      >
        <Row type="flex" justify="end" style={{ marginBottom: "10px" }}>
          <Icon
            type="close"
            style={{ fontSize: "2rem", color: "#818E9B" }}
            onClick={onHandleCancelModal}
          />
        </Row>
        <Spin spinning={this.state.loadingSpin}>
          <Slider {...settings}>{renderImgs}</Slider>
        </Spin>
      </ModalCustom>
    ) : (
      <Modal
        visible={visible}
        onCancel={onHandleCancelModal}
        closable
        width="455px"
        bodyStyle={{
          height: "336px",
          display: "flex",
          flexDirection: "column",
          padding: "48px",
          textAlign: "center",
          fontFamily: "Gilroy, sans-serif",
        }}
        footer={null}
      >
        <Spin spinning={this.state.loadingSpin}>
          <H4>Añadir Imagen</H4>
          <CustomDragger
            action={`${urlEndPoint}/${functionUpload}`}
            beforeUpload={this.beforeUpload}
            customRequest={this.customPost}
            data={{ hola: true }}
            headers={{
              "X-Requested-With": null,
            }}
            showUploadList={false}
          >
            <p className="ant-upload-drag-icon">
              <Icon type="picture" />
            </p>
            <p className="ant-upload-hint">Arrastra aquí</p>
            <p className="ant-upload-hint">ó</p>
            <LinkText>Elige un archivo</LinkText>
          </CustomDragger>
        </Spin>
      </Modal>
    );
  };
}

const GalleryForm = withFirebase(Form.create()(ModalComponent));
export default compose(withApollo)(GalleryForm);
